// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-option-container {
  width: 90%;
  height: 25px;
  margin-left: 5%;
  padding-bottom: 5px;
  flex-shrink: 0;
  display: flex;
  justify-content: space-around;
}
.color-option {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  opacity: 1;
  box-sizing: border-box;
  cursor: pointer;
  animation: slide-left 0.2s ease-in-out 0s 1;
}
.popup-color-more {
  display: inline-block;
  width: 10px;
  position: relative;
  right: 3px;
  top: 4px;
  opacity: 0.7;
  cursor: pointer;
}
.line-option {
  width: 25px;
  margin-right: 5px;
  margin-top: 5px;
  height: 25px;
  border-radius: 50%;
  opacity: 1;
  box-sizing: border-box;
  position: relative;
  bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  animation: slide-right 0.2s ease-in-out 0s 1;
}
@keyframes slide-right {
  0% {
    transform: translateX(30px);
    opacity: 0;
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
}
@keyframes slide-left {
  0% {
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
}
.demo-line {
  width: 80%;
  height: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/colorOption/colorOption.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,2CAA2C;AAC7C;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4CAA4C;AAC9C;AACA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;AACA;EACE,UAAU;EACV,WAAW;AACb","sourcesContent":[".color-option-container {\n  width: 90%;\n  height: 25px;\n  margin-left: 5%;\n  padding-bottom: 5px;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: space-around;\n}\n.color-option {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  opacity: 1;\n  box-sizing: border-box;\n  cursor: pointer;\n  animation: slide-left 0.2s ease-in-out 0s 1;\n}\n.popup-color-more {\n  display: inline-block;\n  width: 10px;\n  position: relative;\n  right: 3px;\n  top: 4px;\n  opacity: 0.7;\n  cursor: pointer;\n}\n.line-option {\n  width: 25px;\n  margin-right: 5px;\n  margin-top: 5px;\n  height: 25px;\n  border-radius: 50%;\n  opacity: 1;\n  box-sizing: border-box;\n  position: relative;\n  bottom: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  animation: slide-right 0.2s ease-in-out 0s 1;\n}\n@keyframes slide-right {\n  0% {\n    transform: translateX(30px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0px);\n    opacity: 1;\n  }\n}\n@keyframes slide-left {\n  0% {\n    transform: translateX(-50px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0px);\n    opacity: 1;\n  }\n}\n.demo-line {\n  width: 80%;\n  height: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
